export default function navigateOrReload(navigate: Function, url: string) {
    if (window.location.href.endsWith(url)) {
      navigate(0);
      return;
    }
  
    navigate(url);
}